import { render, staticRenderFns } from "./dateinput.vue?vue&type=template&id=7635adaf&scoped=true&"
import script from "./dateinput.vue?vue&type=script&lang=js&"
export * from "./dateinput.vue?vue&type=script&lang=js&"
import style0 from "./dateinput.vue?vue&type=style&index=0&id=7635adaf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7635adaf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VFlex,VLayout,VTextField})
